import React from 'react'

interface SliderProps {
    value: number;
    min?: number;
    max?: number;
    step?: number;
    onChange: (value: number) => void;
    disabled?: boolean;
}

export const Slider: React.FC<SliderProps> = ({ value, min = 0, max = 100, step = 1, onChange, disabled }) => {
    return (
        <input
            type="range"
            min={min}
            max={max}
            step={step}
            value={value}
            onChange={(e) => onChange(Number(e.target.value))}
            disabled={disabled}
            className={`
        w-full h-1.5 bg-white/10 rounded-lg appearance-none cursor-pointer 
        accent-primary disabled:opacity-50 disabled:cursor-not-allowed hover:accent-primary/90 transition-all
      `}
        />
    )
}
